import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FiltrarProyectosService {
  filtrosGuardados: any ;

  constructor() { }

  validacionUsuarios() {
    let rol: string | null = null;
    let token: string | null = null;
    let usuarioId: number | null = null;
    
    token = String(localStorage.getItem('token1'));
    // Obtener el rol almacenado en el localStorage (si existe).
    const contenidoRol = localStorage.getItem('rol');

    // Si existe un rol en localStorage, lo asignamos y también obtenemos el ID del usuario.
    if (contenidoRol) {
      rol = contenidoRol; // Asignamos el rol al objeto actual.
      // Convertimos el ID del usuario a número (o null si no existe un valor válido).
      usuarioId = Number(localStorage.getItem('Id_Usuario')) || null;
    } else {
      // Si no hay un rol almacenado, procedemos a verificar los roles asociados al usuario.
      const rolesLlegada = localStorage.getItem('roles_nombre')?.split(',') || []; // Obtener la lista de roles.

      // Si hay roles disponibles en el localStorage.
      if (rolesLlegada.length > 0) {
        let esAdmin = false; // Variable para verificar si el usuario es administrador.

        // Recorremos la lista de roles para comprobar si el usuario es administrador.
        for (const rolTemp of rolesLlegada) {
          // Comparamos cada rol y eliminamos espacios en blanco.
          
          if (rolTemp.trim() === 'Administrador') {
            rol = rolTemp.trim(); // Asignamos el rol dinámicamente con el valor limpio.
            esAdmin = true; // Indicamos que el usuario es administrador.
            break; // Salimos del bucle ya que hemos encontrado el rol de administrador.
          }else{
            rol = rolTemp;
          }
        }

        // Si no se encontró el rol de administrador, asignamos el ID del usuario.
        if (!esAdmin) {
          usuarioId = Number(localStorage.getItem('Id_Usuario'));
        }
      } else {
        console.log('No se encontraron roles en localStorage');
      }
    }

    return { rol, usuarioId, token }; // Retornamos los valores.
  }

  filtrarProyectos(data: any[], usuarioId: number) {
    const proyectosFiltrados = data.filter((proyecto: any) => {
        // Si el FKId_Administrador no es 74
        if (proyecto.FKId_Administrador !== 74) {
            // Solo devolver los proyectos donde el FKId_Administrador coincida con el usuarioId
            return proyecto.FKId_Administrador === usuarioId || proyecto.FKId_Supervisor === usuarioId || proyecto.FKId_Responsable === usuarioId;
        } else {
            // Lógica para cuando el FKId_Administrador es 74 (más de un administrador)

            // Separar los administradores en un array
            const administradoresArray = proyecto.FKId_Administradores?.split(',').map((id: string) => Number(id.trim())); 
            // Filtrar administradores y verificar si el usuarioId está presente
            const esAdministrador = administradoresArray?.filter((id: number) => id === usuarioId).length > 0;

            // Verificar si no es el administrador especial (74)
            const noEsAdminEspecial = !administradoresArray?.some((id: number) => id === 74);

            // Devolver el proyecto solo si el usuario es administrador o si cumple con otras condiciones
            return esAdministrador || (noEsAdminEspecial && (proyecto.FKId_Responsable === usuarioId || proyecto.FKId_Supervisor === usuarioId));
        }
    });

    // Mapear los Id_Proyecto filtrados
    const idProyectos = proyectosFiltrados.map((proyecto: any) => Number(proyecto.Id_Proyecto));

    // Devolver tanto los proyectos filtrados como sus IDs
    return { proyectosFiltrados, idProyectos };
  }


  saveFilter(estatus: any, proyecto: any, mes: any, anio:any, buscar: any, pantalla:string){
    const filtro = { estatus, proyecto, mes, anio, buscar, pantalla };
    this.filtrosGuardados = filtro;
  }

  getFilter(){
    return this.filtrosGuardados;
  }
}
